import * as React from 'react';

import classnames from 'classnames';

import {RadioGroup} from './radio-group';
import type {RadioGroupProps} from './radio-group';

import styles from './radio-group-slider.module.css';

type Props = RadioGroupProps & {
    selectedIndex: number;
};

export class RadioGroupSlider extends React.Component<Props> {
    static defaultProps = {
        size: 'normal',
    };

    render() {
        const {size, selectedIndex, ...radioGroupProps} = this.props;
        const styleNames = classnames(styles['radio-group-slider'], {
            [styles['radio-group-slider--selected-0']]: selectedIndex === 0,
            [styles['radio-group-slider--selected-1']]: selectedIndex === 1,
            [styles['radio-group-slider--selected-2']]: selectedIndex === 2,
            [styles['radio-group-slider--two-items']]:
                this.props.children.filter((child) => Boolean(child)).length === 2,
            [styles['radio-group-slider--three-items']]:
                this.props.children.filter((child) => Boolean(child)).length === 3,
            [styles['radio-group-slider--big']]: size === 'big',
        });

        return (
            <div className={styleNames}>
                <RadioGroup {...radioGroupProps} inline={true} />
            </div>
        );
    }
}
